import { render, staticRenderFns } from "./BasePagination.vue?vue&type=template&id=ed22b3a4&scoped=true&"
import script from "./BasePagination.vue?vue&type=script&lang=js&"
export * from "./BasePagination.vue?vue&type=script&lang=js&"
import style0 from "./BasePagination.vue?vue&type=style&index=0&id=ed22b3a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed22b3a4",
  null
  
)

export default component.exports